<template>
	<div class="content">
		<article class="content">
			<div class="tags" v-if="enrichedArticle.tags">
                <span class="tag is-link hoverable" v-for="cat in enrichedArticle.tags.dpasubject" :qcode="cat.qcode">
                    <span class="name">{{cat.name}}</span>
                    <span class="tagid">{{cat.qcode}}</span>
                </span>
                <span class="tag is-success" v-for="cat in enrichedArticle.tags.dpakeyword" :qcode="cat.qcode">
                    <span class="name">{{cat.name}}</span>
                </span>
                <span class="tag is-warning hoverable" v-for="cat in enrichedArticle.tags.geosubject" :qcode="cat.qcode">
                    <font-awesome-icon :icon="['fas', 'globe-europe']"></font-awesome-icon>
                    <span class="name">{{cat.name}}</span>
                    <span class="tagid">{{cat.qcode}}</span>
                </span>
                <span class="tag is-wiki" v-for="cat in enrichedArticle.tags.wikidata">
                    <template>
                        <font-awesome-icon v-if="cat.type=='dnltype:person'" :icon="['fas', 'user-tag']" />
                        <font-awesome-icon v-if="cat.type=='dnltype:organization'" :icon="['fas', 'building']" />
                        <font-awesome-icon v-if="cat.type=='dnltype:wikidata'" :icon="['fas', 'tag']" />
                    </template>
                    <a :href="cat.url" target="_blank">
                        <span class="name">{{cat.name}}</span>
                    </a>
                </span>
                <span class="tag is-info hoverable" v-for="cat in enrichedArticle.tags.pc">
                    <template>
                        <font-awesome-icon v-if="cat.subtype=='advice-lifetime'" :icon="['fas', 'clock']" />
                        <font-awesome-icon v-if="cat.subtype=='advice-importance'" :icon="['fas', 'exclamation']" />
                        <font-awesome-icon v-if="cat.subtype=='dpa-limbic-system'" :icon="['fas', 'tag']" />
                    </template>
                    <span class="name">{{cat.name}}</span>
                    <span class="tagid">{{cat.qcode}}</span>
                </span>
            </div>
            <h2 v-if="enrichedArticle.kicker != null" class="subtitle is-6">{{enrichedArticle.kicker}}</h2>
			<h1 v-if="enrichedArticle.headline != null" class="title is-4">{{enrichedArticle.headline}}</h1>     
			<!--<router-link class="permalink" :to="{name: '', query: {article: enrichedArticle.urn}}">Permalink</router-link>  -->     
			<div class="info-row">
				<p class="tag is-white date" v-if="enrichedArticle.version_created">{{new Date(Date.parse(enrichedArticle.version_created)).toLocaleString()}}</p>
				<Pie v-if="enrichedArticle['embed-infos']!= undefined" v-bind:infos="enrichedArticle['embed-infos']"></Pie>
			</div>
            <div class="img-box" v-if="featureImageHTML" v-html="featureImageHTML"></div>			
			<p v-if="enrichedArticle.teaser != null" class="teaser">{{enrichedArticle.teaser}}</p>
			<p v-if="enrichedArticle.byline != null" class="author">{{enrichedArticle.byline}}</p>
			<div class="content">
                <ArticleHtml :article_html="enrichedArticle.enriched_html"></ArticleHtml>
                <!--<section v-bind:id="enrichedArticle.urn" v-html="enrichedArticle.enriched_html"></section>-->
			</div>
            <div v-if="correctionNotice" class="correction-notice" v-html="correctionNotice">
            </div>
            <div class="box infobox" v-if="enrichedArticle.infobox_html && !infoboxUsedInPreprocessing">
                <div v-html="enrichedArticle.infobox_html"></div>
            </div>
            <div class="box" v-if="enrichedArticle.linkbox_html">
                <h2 class="title is-5">Weitere Informationen</h2>
                <div v-html="enrichedArticle.linkbox_html"></div>
            </div>
		</article>
	</div>
</template>

<script>
import ArticleElement from './ArticleElement.vue';
import ArticleHtml from './embeds/ArticleHtml.vue';
import Pie from './Pie.vue';

import {feeddata} from '@/../mainconfig/feeddata.js'

//Add fontawesome
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserTag, faBuilding, faTag, faGlobeEurope, faClock, faExclamation} from '@fortawesome/free-solid-svg-icons'
library.add(faUserTag, faBuilding, faTag, faGlobeEurope, faClock, faExclamation)


/**
 * Some little helper functions to seamlessly include entfalter.js and webcomponents into vue
 */
function insertEmbed(domElement, associations, infoboxHtml) {
    //Temporal helper function
    let domain = domElement.getAttribute("href");
    
    //Containing status
    let status = {
        "infoboxUsed": false
    }

    if(domElement.classList.contains("internalLink")){
        if(domElement.getAttribute("data-uri")){
            domElement.outerHTML = `<a class="internal-link" href="./?article=${domElement.getAttribute("data-uri")}">${domElement.innerHTML}</a>`
            return status
        }

        let embedType = domElement.getAttribute("href").split(":")[0];
        let embedData = domElement.getAttribute("href").replace(embedType+":", "");

        switch(embedType){
            case "audio": {
                let audioSrc = `${feeddata.audiofolder}${embedData}.mp3`; 
                domElement.outerHTML = `<dnl-audio src="${audioSrc}"></dnl-audio>`;
            }
            break;
            case "audiocontrol": {
                let audioSrc = `${feeddata.audiofolder}${embedData}.mp3`;
                domElement.outerHTML = `<dnl-audiocontrol src="${audioSrc}"></dnl-audiocontrol>`
            }
            break;
            case "quote": {
                const quoteHTML = domElement.innerHTML,
                    quoteData = quoteHTML.split(" -- ");
                
                domElement.parentElement.outerHTML = `<dnl-quote quote="${quoteData[0]}" author="${quoteData[1]}"></dnl-quote>`;
            }
            break;
            case "gallery": {
                const galleryTitle = domElement.innerHTML;
                let galleryImages = embedData.split(",").map(rankNum => {
                    return associations.find(association => association.rank == parseInt(rankNum))
                })
                
                if(galleryImages.length < 2){
                    galleryImages = associations;
                }
                
                galleryImages = galleryImages.map(img => {
                    return {
                        "title": img.caption,
                        "creditline": img.creditline,
                        "alt": img.headline,
                        "src": img.renditions[0].url,
                        "w": img.renditions[0].width,
                        "h": img.renditions[0].height
                    }
                })

                
                domElement.parentElement.outerHTML = `<dnl-gallery title="${galleryTitle}" imgs='${JSON.stringify(galleryImages)}'></dnl-gallery>`;
                break;
            }
            case "infographic": {
                const graphicTitle = domElement.innerHTML;
                const association = associations.find(d => {
                    return d.urn == embedData
                })

                domElement.parentElement.outerHTML = `<dnl-graphic src="${association.renditions[0].url}" alt="${graphicTitle}" caption="${graphicTitle}"></dnl-graphic>`
                
                break;
            }
            case "img": {
                let association = associations.find(d => {
                    return d.rank == parseInt(embedData);
                }); 
                
                if(!association){
                    association = associations.find(d => {
                        return d.urn == embedData
                    })
                }
                if(association){
                    try{
                        if(domElement.innerHTML.indexOf("Ohne Bildunterzeile") != -1){
                            domElement.parentElement.outerHTML = `<dnl-image class="is-feature" src="${association.renditions[0].url}" alt="${association.headline}" credit="${association.creditline}"></dnl-image>`;
                        }else{
                            domElement.parentElement.outerHTML = `<dnl-image src="${association.renditions[0].url}" alt="${association.caption}" caption="${domElement.innerHTML}" credit="${association.creditline}" ref="${association.urn}"></dnl-image>`;
                        }
                    }catch(e){
                        console.log(e);
                    }
                }else{
                    console.warn(`Error loading image with URN ${embedData}`);
                    domElement.outerHTML = "";
                } 
            }        
            break;
            case "video": {
                let videoSrc = `${feeddata.videofolder}${embedData}.mp4`; 
                domElement.outerHTML = `<dnl-video src="${videoSrc}" caption="${domElement.innerHTML}" credit="dpa-rufa"></dnl-video>`;
            }
            break;
            case "infobox": {
                let temp = document.createElement("html");
                //HOTFIX self-closing web components
                temp.innerHTML = infoboxHtml.replace(`versionScript=2.2"/>`, `versionScript=2.2"></dnl-wgchart>`)
                
                const infoboxElements = temp.querySelectorAll("a");
                
                for (let i = 0; i < infoboxElements.length; i++) {
                    let stats = insertEmbed(infoboxElements[i], associations, null);
                }
                //Little workaround

                domElement.outerHTML = `<dnl-box title="${domElement.innerHTML}" content='${temp.querySelector("section.infobox").innerHTML}'></dnl-box>`;
                status.infoboxUsed = true;
            }
            break;
            case "infobox-start": {
                let temp = document.createElement("html");
                const title = domElement.innerHTML;
                
                let nextEl = domElement.parentElement.nextElementSibling;
                do{
                    let curEl = nextEl;
                    temp.innerHTML += curEl.outerHTML.replace("'", "&#8217;");

                    nextEl = curEl.nextElementSibling;
                    curEl.remove();

                } while(nextEl.firstChild.tagName != "A" || nextEl.firstChild.getAttribute("href").split(":")[0] != "infobox-end");

                temp.innerHTML += nextEl.firstChild.innerHTML;
                nextEl.remove();

                const infoboxElements = temp.querySelectorAll("a");
                for(let i = 0; i < infoboxElements.length; i++){
                    insertEmbed(infoboxElements[i], associations, null)
                }

                domElement.outerHTML = `<dnl-box title="${title}" content='${temp.innerHTML}'></dnl-box> `;
                status.infoboxUsed = true;
                break;
            }
            case "infobox-end":
                break;
            case "data-jpg": {
                let imgSrc = `${feeddata.videofolder}img/${embedData}.jpg`;
                if(domElement.innerHTML.indexOf("Ohne Bildunterzeile") != -1){
                    domElement.outerHTML = `<dnl-image class="is-feature" src="${imgSrc}" credit="dpa"></dnl-image>`;
                }else{
                    domElement.outerHTML = `<dnl-image src="${imgSrc}" credit="dpa" caption="${domElement.innerHTML}"></dnl-image>`;
                }
            }
            break;
            case "ref": {
                domElement.outerHTML = `<a class="internal-link" href="./?article=${embedData}">${domElement.innerHTML}</a>`
                break;
            }
            default:
                console.warn(`${embedType} unknown. Can't render dnl-component`);
        }
    }else{
        let href = domElement.getAttribute("href");
        let host = new URL(href).host;
        
        switch(host){
            /**case "datawrapper.dwcdn.net":
		        domElement.parentElement.outerHTML = `<dnl-dwchart src="${href}"></dnl-dwchart>`;
                break;*/
            case "d30slvg82xq0j0.cloudfront.net":
                domElement.parentElement.outerHTML = `<dnl-wgchart src="${href}"></dnl-wgchart>`;
                break;
            case "embed.dpa-addons.com":
            case "dpa-addons.s3.eu-west-1.amazonaws.com":
            case "d3qbkv8649b17l.cloudfront.net":
                domElement.parentElement.outerHTML = `<dnl-addon src="${href}"></dnl-addon>`;
                break;
            /**case "www.youtube-nocookie.com":
                domElement.parentElement.outerHTML = `<dnl-youtubeembed src="${href}"></dnl-youtubeembed>`;
                break;
            case "twitter.com":
                domElement.parentElement.outerHTML = `<dnl-twitterembed src="${href}"></dnl-twitterembed>`;
                break;*/
            case "dpavideo.23video.com":
                domElement.parentElement.outerHTML = `<div style="width:100%; height:0; position: relative; padding-bottom:56.25%"><iframe src="${href.replace("http:", "")}" style="width:100%; height:100%; position: absolute; top: 0; left: 0;" frameborder="0" border="0" scrolling="no" allowfullscreen="1" mozallowfullscreen="1" webkitallowfullscreen="1" allow="autoplay; fullscreen"></iframe></div>`
                break;
            case "dpa.liveblog.pro":
                domElement.parentElement.outerHTML = `<dnl-liveblog src="${href}"></dnl-liveblog>`;
                break;
            case "www.instagram.com":
                domElement.parentElement.outerHTML = `<dnl-instagramembed src="${href}"></dnl-instagramembed>`;
                break;
            case "www.tiktok.com":
                domElement.parentElement.outerHTML = `<dnl-tiktokembed src="${href}"></dnl-tiktokembed>`;
                break;
            default:
                domElement.setAttribute("target", "_blank");
                domElement.setAttribute("rel", "noopener noreferrer");
                domElement.classList.remove("externalLink");
                console.error(`Host ${host} not allowed`);
        }
    }
    return status;
}
/** End of temporal helper functions block  */

export default {
    name: 'ArticleViewer',
    components: {
        ArticleElement,
        ArticleHtml,
        Pie,
        FontAwesomeIcon
    },
    props: {
        article: Object
    },
    data: function(){
        return {
            infoboxUsedInPreprocessing: false
        }
    },
    computed: {
        featureImageHTML: function(){
            if(this.article.associations.length > 0 && this.article.associations[0].type=='image'){
                let img = this.article.associations[0];  

                let caption = img.caption;
                if(!caption){
                    caption = ""
                }
                return `<dnl-image class="is-feature" alt="${img.renditions[0].url}" src="${img.renditions[0].url}" title="${img.headline}" caption="${caption}" creditline="${img.creditline}"></dnl-image>`;
            }else if(this.article.associations.length && this.article.associations[0].type=='embed'){
                let doc = document.createElement("html");
                doc.innerHTML = this.article.associations[0].embed_html;
                return `<dnl-dwchart src="${doc.querySelector("iframe").getAttribute("src")}"></dnl-dwchart>`;
            }else{
                return null;
            }
        },
        correctionNotice: function(){
            if(["sig:update", "sig:correction", "sig:repeat"].indexOf(this.article.signal) !== -1){
                const correction = this.article.ednotes.find(e => e.role == "dpaednoterole:correctionshort") 
                
                if(correction){
                    return `<p><strong>Hinweis der dpa-Redaktion:</strong> ${correction.ednote}</p>`
                }else{
                    return null
                }
            }
            return null;
        },
        enrichedArticle: function () {
            let enrichedArticle = this.article;

			let articleDom = document.createElement("main");
            articleDom.innerHTML = this.article.article_html;
            
            
            /** Little hacks to make all embeds work */       
            let charts = articleDom.querySelectorAll("a");
            for (let i = 0; i < charts.length; i++) {
                let stats = insertEmbed(charts[i], this.article.associations, this.article.infobox_html);
                this.infoboxUsedInPreprocessing = this.infoboxUsedInPreprocessing || stats.infoboxUsed;
            }       

            let headlines = articleDom.querySelectorAll("h2")
            articleDom.querySelectorAll("h2").forEach(d => {
                d.classList.add("title")
                d.classList.add("is-5")
            })

            articleDom.querySelectorAll("dnl-image").forEach(d => {
                d.setAttribute("src", this.article.associations.find(a => a.urn == d.getAttribute("ref")).renditions[0].url);
            })
            /** Little hacks end */


            let converted_article_html = articleDom.innerHTML;
            //Helpers to get article-tags
            let el = document.createElement("html");
            el.innerHTML = converted_article_html;

            enrichedArticle.enriched_html = articleDom.innerHTML;

            enrichedArticle.tags = {};
            
            enrichedArticle.tags.wikidata = enrichedArticle.categories.filter(d=>{
                return d.qcode && d.qcode.indexOf("wikidata:") == 0
            }).map(d => {
                return {
                    "qcode": d.qcode,
                    "name": d.name,
                    "type": d.type,
                    "url": "https://www.wikidata.org/wiki/"+d.qcode.replace("wikidata:", "")
                }
            });

            enrichedArticle.tags.dpasubject = enrichedArticle.categories.filter(d=>{
                return ["dnltype:dpasubject"].indexOf(d.type) != -1 && enrichedArticle.tags.wikidata.filter(e =>{
                    return e.name.toLowerCase() == d.name.toLowerCase();
                }).length == 0;
            });

            enrichedArticle.tags.dpakeyword = enrichedArticle.categories.filter(d=>{
                return ["dnltype:keyword"].indexOf(d.type) != -1 && enrichedArticle.tags.wikidata.filter(e => {
                    return e.name.toLowerCase() == d.name.toLowerCase();
                }).length == 0;
            });

            enrichedArticle.tags.geosubject = enrichedArticle.categories.filter(d=>{
                return ["dnltype:geosubject"].indexOf(d.type) != -1;
            });

            enrichedArticle.tags.pc = enrichedArticle.categories.filter(d=>{
                return ["dnltype:publishadvice"].indexOf(d.type) != -1;
            }).map(d => {
                return {
                    "qcode": d.qcode,
                    "name": this.capitalizeFirstLetter(d.qcode.split(":")[1]),
                    "type": d.type,
                    "subtype": d.qcode.split(":")[0]
                }
            })

            return enrichedArticle;
        }
    },
    methods: {
        capitalizeFirstLetter:  function(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }
}

//Replace all
String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};
</script>

<style>
h1.title.is-4{
	margin-bottom: 0;
}

.tag.date{
	padding-left: 0;
	margin-bottom: 30px;
}

article.content{
	margin: 30px auto;
	max-width: 700px;
}

div.content{
	margin-top: 30px
}

.teaser{
	font-weight: 600;
}

.author{
	font-style: italic;
}

.subheading{
	font-weight: 600;
	font-size: 1.2em;
}

.info-row{
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
	margin-top: 10px;
}

.info-row .chart, .info-row p.date{
	margin-bottom: 0 !important;
}

.info-header, .info-text{
	background: #CCC;
}

.info-header{
	font-size: 1.4em;
	font-weight: 600;
	margin-bottom: 0 !important;
	padding: 20px;
}

.info-text{
	padding: 0 25px 30px 40px;
}

.img-box{
	margin-bottom: 40px;
}

.img-box iframe{
	max-width: 500px
}

.content .img-box p.img-title{
    font-weight: 600;
    margin-bottom: 3px;
}

.img-box .subtitle, .img-box .credit{
	font-size: 0.7em;
}

.img-box .credit{
	font-style: italic;
	text-align: right;
}

.linkbox-container{
    background: #E2E3E4;
    padding: 20px;
}

.infobox h2.subheading{
    font-size: 1.25rem;
}

.footer{
	background: none;
	font-size: 0.8em;
	font-style: italic
}

a.permalink{
	font-size: 11px;
}

.tags .tag{
    border: 1px solid #FFF;
}

.tags .tag.hoverable{
    cursor: pointer;
}

.tags .tag.is-wiki{
    background: #990000;
}

.tags .tag.is-wiki  a{
    color: #eee;
}

.tags .tag.is-dark a:hover{
    color: #9F9E9E;
}

.tag.hoverable:active{
    border-color: #333
}

.tag.hoverable:active span.name{
    display: none
}

.tag.hoverable span.tagid{
    display: none;
}

.tag.hoverable:active span.tagid{
    display: block;
}

.tag svg{
    margin-right: 5px;
}

.tag:not(.is-warning) svg{
    color: #FFF;
}

a.internal-link{
    display: block;
    font-weight: 600;
    margin: 25px 0;
    text-decoration: underline;
}

.box.infobox{
    box-shadow: none;
    background: #eee;
    border: 2px solid #eee;
    border-radius: 6px;
    padding: 20px 40px;

    color: #4a4a4a;
}

.box.infobox h2 {
    font-size: 1.5em;
    color: #4a4a4a;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
}

.box.infobox ul {
    color: #4a4a4a;
}

.correction-notice {
    font-size: small;
    margin: 20px 0;
}

.correction-notice p{
    margin-bottom: 0 !important;
}

.content .correction-notice ul {
    margin-top: 0;
}

.content dnl-tiktokembed blockquote{
    background: none;
    border: none;
    padding: none;

}

dnl-graphic,
dnl-image {
    margin: 20px 0;
}

@media (max-width: 786px){
	.info-row{
		align-items: baseline;
		flex-flow: column;
	}
}

@media (max-width: 700px){
    article.content{
        max-width: calc(100vw - 40px);
    }
}
</style>
